import Modal from "@/common/components/Modal"
import { zodResolver } from "@hookform/resolvers/zod"
import { useForm, SubmitHandler } from "react-hook-form"
import TextArea from "@/common/components/TextArea"
import { Dispatch, SetStateAction, useState } from "react"
import { declineSchema, PrivateCompanyLeadsFunnelDeclineValidationSchema } from "@/features/privateCompanyLeadsFunnel/schemas/decline.schema"
import { useUnblockPos } from "@/features/pos/hooks/useUnblockPos"
import { UnblockPosValidationSchema } from "../../schemas/unblockPos.schema"
import { useParams } from "react-router-dom"

interface UnblockPosModalProps {
  isOpen: boolean
  setIsOpen: Dispatch<SetStateAction<boolean>>
  onSuccess?: () => void
  onError?: () => void
}

const UnblockPosModal = ({isOpen, setIsOpen, onSuccess, onError }: UnblockPosModalProps) => {
  const {id} = useParams()
  const [serverError, setServerError] = useState(false)
  const {
    register,
    handleSubmit,
    reset: resetForm,
    formState: { errors }
  } = useForm<PrivateCompanyLeadsFunnelDeclineValidationSchema>({
    resolver: zodResolver(declineSchema)
  })

  const {mutate, isPending} = useUnblockPos({
    id,
    onSuccess: () => {
      resetForm();
      setServerError(false);
      setIsOpen(false);
      onSuccess?.();
    },
    onError: () => {
      setServerError(true);
      onError?.();
    },
  });

  const onSubmit: SubmitHandler<UnblockPosValidationSchema> = (data) => {
    mutate(data);
  }

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      onConfirm={handleSubmit(onSubmit)}
      disabled={isPending}
      title="Justificativa para desbloqueio"
      titleClass="text-2xl font-bold mb-2"
      subtitle="Preencha o motivo para desbloquear o POS"
      footer="Confirmar justificativa e salvar alteração"
      body={(
        <form className="flex flex-col gap-4">
          {serverError && <p className="text-sm text-danger-soft">Ocorreu um erro no servidor, cheque os campos e tente novamente</p>}
          <TextArea
            label="Justificativa"
            placeholder="Escreva aqui sua justificativa"
            errorMessage={errors?.description?.message}
            {...register('description')}
          />
        </form>
      )}
    />
  )
}

export default UnblockPosModal